module.exports = __webpack_public_path__ + "static/media/processing-entreprenur.979a8b72.jpg";